
import { AppSection, Article } from "@soenergy/frontend-library"

export default {
  components: {
    AppSection,
    Article
  },
  props: {
    images: {
      type: [Array, String],
      default: null
    },
    quote: {
      type: [Object, String],
      default: null
    },
    name: {
      type: String,
      default: null
    },
    fontColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    }
  }
}
